module.exports = __webpack_public_path__ + "img/threejs.dcbd7fee.svg";